module.exports = __webpack_public_path__ + "static/media/leads.70639fcd.svg";